<ng-container *ngComponentOutlet="data.component; injector: componentInjector"></ng-container>
